"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrNode = exports.StrChunk = void 0;
const clock_1 = require("../../../json-crdt-patch/clock");
const AbstractRga_1 = require("../rga/AbstractRga");
const util_1 = require("sonic-forest/lib/util");
const json_crdt_patch_1 = require("../../../json-crdt-patch");
const constants_1 = require("../../../json-crdt-patch/constants");
/**
 * @ignore
 * @category CRDT Node
 */
class StrChunk {
    constructor(id, span, str) {
        this.id = id;
        this.span = span;
        this.len = str ? span : 0;
        this.del = !str;
        this.p = undefined;
        this.l = undefined;
        this.r = undefined;
        this.p2 = undefined;
        this.l2 = undefined;
        this.r2 = undefined;
        this.s = undefined;
        this.data = str;
    }
    merge(str) {
        this.data += str;
        this.span = this.data.length;
    }
    split(ticks) {
        if (!this.del) {
            const chunk = new StrChunk((0, clock_1.tick)(this.id, ticks), this.span - ticks, this.data.slice(ticks));
            this.data = this.data.slice(0, ticks);
            this.span = ticks;
            return chunk;
        }
        const chunk = new StrChunk((0, clock_1.tick)(this.id, ticks), this.span - ticks, '');
        this.span = ticks;
        return chunk;
    }
    delete() {
        this.del = true;
        this.data = '';
    }
    /**
     * - `id`, `span`, `len`, `del`, `data`: copied, set by constructor
     * - `p`, `l`, `r`, `p2`, `l2`, `r2`, `s`: not copied, set when inserted into RGA
     */
    clone() {
        const chunk = new StrChunk(this.id, this.span, this.data);
        return chunk;
    }
    view() {
        return this.data;
    }
}
exports.StrChunk = StrChunk;
/**
 * Represents the `str` type in JSON CRDT. The `str` type is a RGA (Replicated
 * Growable Array) of UTF-16 code units.
 *
 * @category CRDT Node
 */
class StrNode extends AbstractRga_1.AbstractRga {
    constructor() {
        // ----------------------------------------------------------------- JsonNode
        super(...arguments);
        /** @ignore */
        this._view = '';
        /** @ignore */
        this.api = undefined;
        /** @ignore */
        this.parent = undefined;
    }
    /** @ignore */
    children() { }
    /** @ignore */
    child() {
        return undefined;
    }
    /** @ignore */
    container() {
        return undefined;
    }
    view() {
        if (this._view)
            return this._view;
        let str = '';
        for (let chunk = this.first(); chunk; chunk = (0, util_1.next)(chunk))
            // TODO: Check if this optimization improves performance: if (!chunk.del) str += chunk.data;
            str += chunk.data;
        return (this._view = str);
    }
    name() {
        return 'str';
    }
    /** @ignore */
    clone() {
        const clone = new StrNode(this.id);
        const count = this.count;
        if (!count)
            return clone;
        let chunk = this.first();
        clone.ingest(count, () => {
            const ret = chunk.clone();
            chunk = this.next(chunk);
            return ret;
        });
        return clone;
    }
    /** @ignore */
    delta(model, cc, ops) {
        const obj = this.id;
        if (!cc.has(obj))
            ops.push(new json_crdt_patch_1.NewStrOp(obj));
        const iterator = this.iterator();
        let lastChunk;
        while (true) {
            const chunk = iterator();
            if (!chunk)
                break;
            const { id, span, del } = chunk;
            const gap = cc.gap((0, clock_1.tick)(id, span - 1));
            if (gap > 0) {
                const offset = Math.max(0, span - gap);
                const data = chunk.data || ' '.repeat(span);
                if (!offset) {
                    const ref = lastChunk ? (0, clock_1.tick)(lastChunk.id, lastChunk.span - 1) : obj;
                    ops.push(new json_crdt_patch_1.InsStrOp(id, obj, ref, data));
                }
                else {
                    const text = data.slice(offset);
                    const ref = (0, clock_1.tick)(id, offset - 1);
                    ops.push(new json_crdt_patch_1.InsStrOp((0, clock_1.tick)(id, offset), obj, ref, text));
                }
            }
            if (del)
                ops.push(new json_crdt_patch_1.DelOp(constants_1.ORIGIN, obj, [(0, clock_1.tss)(id.sid, id.time, span)]));
            lastChunk = chunk;
        }
    }
    // -------------------------------------------------------------- AbstractRga
    /** @ignore */
    createChunk(id, str) {
        return new StrChunk(id, str ? str.length : 0, str || '');
    }
    /** @ignore */
    onChange() {
        this._view = '';
    }
    toStringName() {
        return this.name();
    }
}
exports.StrNode = StrNode;
